import cssVars from '../../../styles/variables';

const partnerAuthSharedStyles = {
  labelStyle: {
    color: cssVars['--off-white'],
  },
  selectFieldStyle: {
    width: '100%',
    borderTop: 'none',
    fontWeight: '300',
    borderRight: 'none',
    borderBottom: `1px solid ${cssVars['--ink-med-dark']}`,
    borderLeft: 'none',
    color: `${cssVars['--off-white']}`,
    backgroundColor: `${cssVars['--ink-11']}`,
    fontSize: '18px',
    fontFamily: `${cssVars['--auxiliary-font-header']}`,
    height: '33px',
    boxSizing: 'border-box',
    marginTop: '0px',
    paddingLeft: '0px',
  },
  selectLabelStyle: {
    lineHeight: '18px',
    color: `${cssVars['--off-white']}`,
    fontSize: '12px',
  },
};

export const inputCheckmarkSvgProps = {
  width: '20px',
  height: '15px',
  viewBox: '0 0 13 11',
  fill: cssVars['--off-white'],
};

export const selectElementStyling = {
  selectFieldStyle: partnerAuthSharedStyles.selectFieldStyle,
  selectLabelStyle: partnerAuthSharedStyles.selectLabelStyle,
};

export default partnerAuthSharedStyles;
